import * as THREE from 'three';
import { Font } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import { Renderer } from "@components/Graphics/Renderer";


export class TextRenderer3D extends Renderer {
    font?: Font
    geometry?: TextGeometry
    mesh?: THREE.Mesh
    private _lastData!: { text: string, color: number, curveSegments: number }
    private _data: { text: string, color: number, curveSegments: number } = { text: '', color: 0xffffff, curveSegments: 12 }
    set text(text: string) { this._data.text = text; this.reloadGeometry(); }
    set color(color: number) { this._data.color = color; this.reloadGeometry(); }
    set curveSegments(curveSegments: number) { this._data.curveSegments = curveSegments; this.reloadGeometry(); }
    get text() { return this._data.text }
    get color() { return this._data.color }
    get curveSegments() { return this._data.curveSegments }
    setup(_data: any) {
        super.setup(_data)
        this.engine.assetLoader.loadFont('/resources/fonts/Roboto_Regular.json').then((font) => {
            this.font = font
            this.onAssetLoaded()
        })
        this.text = _data.text || this._data.text
        this.color = _data.color || this._data.color
        this._lastData = { ...this._data }
        this.curveSegments = _data.curveSegments || this._data.curveSegments

    }
    reloadGeometry(forced = false) {
        if (!forced) {
            if (!this.font) return
            if (!this._lastData) return
            if (this._lastData === this._data) return
        }
        if (this.mesh) {
            this.object3D.remove(this.mesh)

            if (this.mesh.geometry) {
                this.mesh.geometry.dispose()
            }

            if (this.mesh.material) {
                if (Array.isArray(this.mesh.material)) {
                    this.mesh.material.forEach(m => m.dispose())
                } else {
                    this.mesh.material.dispose()
                }
            }

            this.mesh = undefined
        }
        const geometry = new TextGeometry(this.text, {
            font: this.font!,
            size: 1,
            depth: 0.1,
            curveSegments: this.curveSegments
        })

        const material = new THREE.MeshStandardMaterial({
            color: this.color
        })
        this.mesh = new THREE.Mesh(geometry, material)
        this.object3D.add(this.mesh)
        super.onMove()
        this._lastData = { ...this._data }
    }
    onAssetLoaded() {
        this.reloadGeometry(true)
        //this.mesh = new THREE.Mesh(this.geometry, new THREE.MeshBasicMaterial({ color: this.color }))
        //this.object3D.add(this.mesh)
    }
    start() {
        super.start()
    }
    update(_dt: number) {

    }
    onMove() {
        super.onMove()
    }
    onDestroy() {
        if (this.mesh) this.object3D.remove(this.mesh)
        super.onDestroy()
    }
}
